import palette from "./palette";
import typography from "./typography";

export default {
    //Navbar and footer text style
    nFamily: 'Times New Roman',
    nSize: typography.bigText,
    nSizeMobile: typography.smallText,
    fSize: typography.smallText,
    nColor: palette.black,
    nStyle: 'italic',

    //Mainpage
    mFamily: 'Times New Roman',
    mSize: typography.iconText,
    mColor: palette.black,
    mStyle: 'italic',

    //Mainpage Header
    mhSize: typography.bigText,
}